export default __webpack_public_path__ + "static/media/mnav-b.95c71d2b.svg";